function toggleTheme(){
  var r=document.documentElement;
  var next=r.getAttribute('data-theme')==='dark'?'light':'dark';
  r.setAttribute('data-theme',next);
  try{localStorage.setItem('heft-theme',next)}catch(e){}
}
function toggleDrawer(open){
  var n=document.getElementById('mainnav');
  var s=document.getElementById('navScrim');
  var h=document.querySelector('.masthead');
  if(!n||!s)return;
  n.inert=!open&&window.matchMedia('(max-width:900px)').matches;
  n.classList.toggle('open',open);
  s.classList.toggle('show',open);
  if(h&&document.body.classList.contains('home')){
    h.style.zIndex=open?'80':'';
  }
  document.body.style.overflow=open?'hidden':'';
  var opener=document.querySelector('.menu-btn');
  if(opener)opener.setAttribute('aria-expanded',String(open));
  if(open){var close=n.querySelector('.drawer-close');if(close)close.focus();}
  else if(opener)opener.focus();
}
try{
  var saved=localStorage.getItem('heft-theme');
  if(saved){document.documentElement.setAttribute('data-theme',saved)}
  else{
    var h=new Date().getHours();
    document.documentElement.setAttribute('data-theme',(h>=19||h<7)?'dark':'light');
  }
}catch(e){}

document.addEventListener('keydown',function(event){
  var n=document.getElementById('mainnav');
  if(!n||!n.classList.contains('open'))return;
  if(event.key==='Escape'){event.preventDefault();toggleDrawer(false);}
  if(event.key==='Tab'){
    var items=Array.from(n.querySelectorAll('a[href],button')).filter(function(el){return el.getClientRects().length;});
    var first=items[0],last=items[items.length-1];
    if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
    else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
  }
});

(function(){
  var media=window.matchMedia('(max-width:900px)');
  function syncNav(){var nav=document.getElementById('mainnav');if(nav)nav.inert=media.matches&&!nav.classList.contains('open');}
  media.addEventListener('change',syncNav);syncNav();
})();
